import { useEffect, useState } from 'preact/hooks';
import { getAuthStatus, loginWithPasskey, registerPasskey } from '../lib/webauthn-client';
import './../styles/components/login.css';

export function LoginPage() {
  const [mode, setMode] = useState<'loading' | 'login' | 'first-time' | 'error'>('loading');
  const [error, setError] = useState<string | null>(null);
  const [bootstrapToken, setBootstrapToken] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getAuthStatus()
      .then((status) => {
        if (status.devBypass) {
          window.location.replace('/');
          return;
        }
        setMode(status.hasDevices ? 'login' : 'first-time');
      })
      .catch((e) => {
        setError((e as Error).message);
        setMode('error');
      });
  }, []);

  async function handleLogin() {
    setBusy(true);
    setError(null);
    try {
      await loginWithPasskey();
      window.location.replace('/');
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function handleRegister() {
    setBusy(true);
    setError(null);
    try {
      await registerPasskey(bootstrapToken || undefined);
      window.location.replace('/');
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main class="login">
      <div class="login-card">
        <h1 class="login-title">MyNetWorth</h1>
        {mode === 'loading' && <p class="login-sub">…</p>}
        {mode === 'login' && (
          <>
            <p class="login-sub">Sign in with your passkey</p>
            <button class="login-btn" onClick={handleLogin} disabled={busy}>
              {busy ? 'Authenticating…' : 'Use passkey'}
            </button>
          </>
        )}
        {mode === 'first-time' && (
          <>
            <p class="login-sub">First-time setup. Paste your bootstrap token, then register a passkey.</p>
            <input
              class="login-input"
              type="password"
              placeholder="Bootstrap token"
              value={bootstrapToken}
              onInput={(e) => setBootstrapToken((e.target as HTMLInputElement).value)}
            />
            <button class="login-btn" onClick={handleRegister} disabled={busy || !bootstrapToken}>
              {busy ? 'Registering…' : 'Register passkey'}
            </button>
          </>
        )}
        {error && <p class="login-error">{error}</p>}
      </div>
    </main>
  );
}
